"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Line = (props) => {
    const { globalScaleFactor, lineWidth, lineColor, lineType } = props;
    const dimension = 20 * globalScaleFactor; //TODO: ensure that web uses 20 and mobile uses 40 as a basis
    // first number is filled distance, followed by unfilled distance, this pattern will repeat along the line
    const strokeDashArray = lineType === 'dashed' ? '5,5' : '';
    const points = [
        [2 * globalScaleFactor, 10 * globalScaleFactor],
        [18 * globalScaleFactor, 10 * globalScaleFactor],
    ];
    const stringPoints = points.map((nums) => nums.toString()).join(', ');
    return `
    <svg
      width="${dimension}"
      height="${dimension}"
      view-box="0 0 ${dimension} ${dimension}"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
        <polyline
          points="${stringPoints}"
          fill="none"
          stroke="${lineColor ? `#${lineColor}` : '#fff'}"
          stroke-width="${lineWidth ? `${lineWidth}` : 2}"
          stroke-dasharray="${strokeDashArray}"
        />
    </svg>`;
};
exports.default = Line;
//# sourceMappingURL=LineBuilder.js.map